<script setup lang="ts">
import { DateTime } from 'luxon'

import { useEmployeeShiftOfferDialog } from '../composables/useEmployeeShiftOfferDialog'

const { hide, isShown, offer, employee } = useEmployeeShiftOfferDialog()
</script>

<template>
  <Dialog
    :visible="isShown"
    title="Offer Details"
    dismissable-mask
    modal
    @update:visible="hide"
  >
    <template #header>
      <div>
        <div v-if="employee" class="flex items-center">
          <Avatar
            :label="employee.firstName.charAt(0) + employee.lastName.charAt(0)"
            :image="employee.avatarUrl"
            class="bg-highlight"
            shape="circle"
            size="large"
          />
          <div class="ml-4">
            <div class="font-medium">
              {{ employee.firstName }} {{ employee.lastName }}
            </div>
            <div class="text-muted-color">
              {{ employee.email }}
            </div>
          </div>
        </div>
        <div v-else>No employee selected</div>
      </div>
    </template>

    <Divider />

    <div v-if="offer">
      <div>
        <span>Employee ID:</span>
        <span>{{ offer.employeeId }}</span>
      </div>
      <div>
        <span>Shift ID:</span>
        <span>{{ offer.shiftId }}</span>
      </div>

      <Divider />

      <div class="grid grid-cols-4 gap-8">
        <div class="col-span-4 text-center">
          <span>Check In</span>
        </div>
        <span class="text-center">{{
          offer.checkedInAt?.toLocaleString(DateTime.DATETIME_MED) ??
          'No Check In'
        }}</span>
        <span class="text-center">{{
          offer.checkInLat ?? 'No Location Lat'
        }}</span>
        <span class="text-center">{{
          offer.checkInLng ?? 'No Location Lng'
        }}</span>
        <span class="text-center">{{
          (offer.checkInNote?.length ?? 0) > 0 ? offer.checkInNote : 'No Note'
        }}</span>
        <div class="col-span-4 text-center">
          <span>Check Out</span>
        </div>
        <span class="text-center">{{
          offer.checkedOutAt?.toLocaleString(DateTime.DATETIME_MED) ??
          'No Check Out'
        }}</span>
        <span class="text-center">{{
          offer.checkOutLat ?? 'No Location Lat'
        }}</span>
        <span class="text-center">{{
          offer.checkOutLng ?? 'No Location Lng'
        }}</span>
        <span class="text-center">{{
          (offer.checkOutNote?.length ?? 0) > 0 ? offer.checkOutNote : 'No Note'
        }}</span>
      </div>
    </div>

    <div v-else>No offer selected</div>
  </Dialog>
</template>
